// src/config/account.js
// DEFAULT_ACCOUNT: migrated verbatim from prototype lines 5538-5542.
// DEFAULT_EXAM_DATES: migrated verbatim from prototype lines 5551-5556.
// DEFAULT_EMAIL_NOTIFICATIONS: migrated verbatim from prototype lines 5558-5562.

export const DEFAULT_ACCOUNT = {
    welcomeTagline: 'My Account',
    examCountdownDescription: 'Set your exam date to keep focus.',
    progressDescription: 'Set texts completed'
};

// Slice 1b de-seed: empty by default. Danielle adds entries ({ id, label, date }) via the
// admin Exam Dates editor; they hydrate from /config/exam-dates (Danielle-managed).
export const DEFAULT_EXAM_DATES = [];

export const DEFAULT_EMAIL_NOTIFICATIONS = {
    reminder14: true,
    reminder3:  true,
    reminderDay: true
};
